const tracker = (userId = '') =>
` <!-- Iterio loader start -->
  <script>
    window.iterio=window.iterio||function(){(iterio.q=iterio.q||[]).push(arguments)};iterio.l=+new Date;
    iterio('load', ${userId});
  </script>
  <script async src="https://cdn.iteriodata.com/i.min.js"></script>
  <!-- Iterio loader end -->
`;

export default tracker;



// WEBPACK FOOTER //
// ./src/scripts/tracker.js